export var selectNodeSelectionSnapshots = function (state) {
    return state.undoSnapshots.nodeSelections;
};
